import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {validateEmpty} from '../../../../global/custom-validate';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {UploadFileComponent} from '../../../ui/upload/uploadfile.component';
import {Subject} from 'rxjs';
import {DatePipe} from '@angular/common';
import {GroupSelectComponent} from '../../group/groupselect.component';
import {CommandUtil} from '../../../../global/commandutil';
import {VanBanDiService} from '../../../../service/vanbandi/service-vanbandi';
import {environment} from '../../../../../environments/environment';
import {VanBanDiXLService} from '../../../../service/vanbandi/service-vanbandixl';
import {Staffs} from '../../../../models/staff/staffs';
import {VanBanDi} from '../../../../models/vanbandi/vanbandi';

@Component({
  templateUrl: './docvanban.component.html'

})
export class DocVanBanDiComponent implements OnInit, AfterViewInit {

  @ViewChild(UploadFileComponent)
  public uploadFileComponent: UploadFileComponent;
  public language = language;
  public id: number=0;
  public frmGroup: FormGroup;
  public isEdit: boolean = false;
  public submitValidate = false;
  public dateThoiHan: Date;
  public staffSingerList: Object[] =[];
  public staffsList: Staffs[]=[];
  public  onClose: Subject<boolean>;
  public vanBanDiItem: VanBanDi=new VanBanDi();
  constructor(
    public vanBanDiGiaoXLService: VanBanDiXLService,
    public formBuilder: FormBuilder,
    public toastr: ToastrService,
    public bsModalService: BsModalService,
    public datepipe: DatePipe,
    public _bsModalRef: BsModalRef,
    public commandUtils: CommandUtil,
    public vanBanDiService: VanBanDiService
  ) {
  }
  ngAfterViewInit() {

  }

  toggleDropdown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
  }
  public edit(id: number) {
    this.id= id;
    this.isEdit =(id!=0)? true: false;
    this.vanBanDiService.getById(id).subscribe(data => this.vanBanDiItem = data);

  }
  public deleteItem(id: number)
  {
    this.staffsList.splice(this.staffsList.findIndex(x=> x.id === id),1);
  }
  ngOnInit(): void {
    this.onClose = new Subject();
    this.frmGroup = new FormGroup({
      usersRead: new FormControl(),
      id: new FormControl(),
    });
    this.frmGroup = this.formBuilder.group({
      usersRead: ['', Validators.nullValidator],
      id: ['', Validators.nullValidator]
    });

  }
  get f() { return this.frmGroup.controls; }

  public showSinger()
  {
    const modalEdit = this.bsModalService.show(GroupSelectComponent, {class: 'modal-lg'});
    (<GroupSelectComponent>modalEdit.content).showDonVi(
      this.staffSingerList
    );
    (<GroupSelectComponent>modalEdit.content).selectStaffs.subscribe(result => {
      if(result != null)
      {
        for(let i= 0;i< result.length;i++)  {
          if(this.staffsList.findIndex(y=> y.id === result[i].id) === -1)
            this.staffsList.push((result[i]));
        }
      }
    });
  }
  public actionXuLy()
  {
    this.vanBanDiService.updateUsersRead(this.id, this.frmGroup.value.usersRead).subscribe(
      {    next: (data) => {
          this.toastr.success(language.message_gandoc_success, language.message);
        },
        error: error => {
          this.toastr.error(language.error, language.message);
        }
      });
  }
  public onSubmit()
  {
    this.submitValidate = true;
    this.frmGroup.value.usersRead = this.staffsList.map(x=>x.id).join().toString();
    if(this.staffsList.length ==0 ) {
      this.toastr.error(language.messagechonnguoidoc, language.message);
      return;
    }
    this.actionXuLy();
    this.onClose.next(true);
    this._bsModalRef.hide();

  }
  public onSave(): void {

    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public onCancel(): void {
    this.onClose.next(true);
    this._bsModalRef.hide();
  }

  public hideConfirmationModal(): void {
    this.onClose.next(null);
    this._bsModalRef.hide();
  }

}

